import { render, staticRenderFns } from "./LookBookList.vue?vue&type=template&id=12bce8df&scoped=true&"
import script from "./LookBookList.vue?vue&type=script&lang=js&"
export * from "./LookBookList.vue?vue&type=script&lang=js&"
import style0 from "./LookBookList.vue?vue&type=style&index=0&id=12bce8df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bce8df",
  null
  
)

export default component.exports